import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "button"

  connect() {
    super.connect()
    this.#addButton()
  }

  disconnect() {
    this.#removeButton()
    super.disconnect()
  }

  #addButton() {
    const element = this.bridgeElement

    const iosImage = element.bridgeAttribute("ios-image")
    const androidImage = element.bridgeAttribute("android-image")
    const side = element.bridgeAttribute("side")
    const action = element.bridgeAttribute("action")

    const data = {
      title: element.title,
      iosImage,
      androidImage,
      side,
      action
    }

    this.send("connect", data, () => {
      this.element.click()
    })
  }

  #removeButton() {
    this.send("disconnect")
  }
}